import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Button, Heading, InlineNotification, Text } from '@frontend/design-system';
import { useGetLocationDetails } from '../../../hooks/api-hooks/use-get-location-details';
import Footer from '../../layout/footer.component';
import { containerCardStyles } from './patron-form-welcome-screen.styles';

interface Props {
  locationId: string;
  officeName?: string;
  patientFirstName?: string;
  onAccept: () => void;
}

export const PatronFormWelcomeScreen: FC<Props> = ({ locationId, officeName, patientFirstName, onAccept }) => {
  const { t } = useTranslation('digital-forms-experience');
  const { locationDetails } = useGetLocationDetails(locationId, !officeName);

  const companyName = locationDetails?.location_nickname || locationDetails?.name || '';
  const hasPatientName = Boolean(patientFirstName);

  return (
    <>
      <div css={containerCardStyles}>
        <Heading as='h1' level={2}>
          {hasPatientName ? t('Welcome, {{firstName}}', { firstName: patientFirstName }) : t('Welcome')}
        </Heading>
        <Text>
          {hasPatientName
            ? t(
                'Thank you for choosing {{companyName}}. Please take a moment to verify and fill out the required information.',
                { companyName: officeName || companyName || t('us') }
              )
            : t('Thank you for choosing {{companyName}}. Please take a moment to fill out the required information.', {
                companyName: officeName || companyName || t('us'),
              })}
        </Text>
        <InlineNotification
          status='warn'
          message={t(
            "Please only complete this form on a trusted device. If you're using a public device, please use caution when entering sensitive or personal information. Always close your browser window and permanently delete any file downloads when finished."
          )}
        />
        <Button variant='primary' size='large' onClick={onAccept}>
          {t('Accept & Continue')}
        </Button>
      </div>
      <Footer />
    </>
  );
};
